export enum CookiesKey {
  Lang = 'lang',
}
